
export const UserTypes = {
    CLIENT: 'CLIENT',
    EMPLOYEE: 'EMPLOYEE',
    ADMIN: 'ADMIN',
}

